query GetEmailableQuotesByLeadIds($leadIds: [ID!]!, $documentType: SalesDocumentVariant) {
    quotesForSend(leadIds: $leadIds, documentType: $documentType) {
        id
        shareableViewInBrowserLink
    }
}
